import { useState } from "react";
import { Eye, EyeOff, Mail, Lock, Loader2 } from "lucide-react";
import CryptoJS from "crypto-js";
import { showError } from "../lib/toast";
import { server_post_data, login_to_admin } from "../serviceconnection/ServiceConnection";
import { storeData } from "../localconnection/LocalConnection";



// ─────────────────────────────────────────────────────────────────────────────
export default function Login() {
  const [form, setForm]           = useState({ useremail: "", userpassword: "" });
  const [showPass, setShowPass]   = useState(false);
  const [loading, setLoading]     = useState(false);

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!form.useremail.trim()) { showError("Email is required");    return; }
    if (!form.userpassword)     { showError("Password is required"); return; }

    try {
      setLoading(true);
      const fd = new FormData();
      fd.append("useremail",    form.useremail.trim().toLowerCase());
      fd.append("userpassword", form.userpassword);
      fd.append("email_mobile", "Email");
      fd.append("flag_for_login", "1");

      const res  = await server_post_data(login_to_admin, fd);
      const data = res.data;

      if (data?.error) {
        showError(data?.message || "Login failed");
        return;
      }

      const msg = data?.message;

      // ── Store in localStorage ─────────────────────────────────────────────
      storeData("admin_data",        JSON.stringify(msg?.data_admin        ?? {}));
      storeData("designation_data",  JSON.stringify(msg?.data_designation  ?? {}));
      storeData("admin_image_base",  msg?.data_admin_image ?? "");
      // localStorage.setItem("access_token",      msg?.tokens ?? "");

      // ── Redirect ──────────────────────────────────────────────────────────
      window.location.href = "/dashboard";

    } catch (err) {
      showError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4"
      style={{ background: "hsl(var(--background))" }}>

      {/* Card */}
      <div className="w-full max-w-md space-y-8">

        {/* Logo / Brand */}
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-2"
            style={{ background: "var(--gradient-hero)" }}>
            <span className="text-white text-2xl font-black">T</span>
          </div>
          <h1 className="text-2xl font-bold text-foreground">ThynkProcess</h1>
          <p className="text-sm text-muted-foreground">Admin Panel — Sign in to continue</p>
        </div>

        {/* Form Card */}
        <div className="cms-card p-8 space-y-5">

          <div className="space-y-1">
            <h2 className="text-lg font-semibold text-foreground">Welcome back</h2>
            <p className="text-xs text-muted-foreground">Enter your credentials to access the dashboard</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">

            {/* Email */}
            <div className="space-y-1.5">
              <label className="text-xs font-semibold text-muted-foreground">Email Address</label>
              <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border bg-background transition-colors
                ${form.useremail ? "border-accent/60" : "border-border"} focus-within:border-accent`}>
                <Mail className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                <input
                  name="useremail"
                  type="email"
                  value={form.useremail}
                  onChange={handleChange}
                  placeholder="admin@thynkprocess.com"
                  autoComplete="email"
                  className="flex-1 bg-transparent outline-none text-sm text-foreground placeholder:text-muted-foreground"
                />
              </div>
            </div>

            {/* Password */}
            <div className="space-y-1.5">
              <label className="text-xs font-semibold text-muted-foreground">Password</label>
              <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border bg-background transition-colors
                ${form.userpassword ? "border-accent/60" : "border-border"} focus-within:border-accent`}>
                <Lock className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                <input
                  name="userpassword"
                  type={showPass ? "text" : "password"}
                  value={form.userpassword}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  className="flex-1 bg-transparent outline-none text-sm text-foreground placeholder:text-muted-foreground"
                />
                <button type="button" onClick={() => setShowPass((p) => !p)}
                  className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0">
                  {showPass ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-semibold text-white transition-all disabled:opacity-60 disabled:cursor-not-allowed mt-2"
              style={{ background: "var(--gradient-hero)" }}>
              {loading
                ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in...</>
                : "Sign In"}
            </button>

          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} ThynkProcess. All rights reserved.
        </p>
      </div>
    </div>
  );
}